import { Component, Output, EventEmitter, ChangeDetectorRef, NgZone, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Loader } from '../../components/loader/loader';

@Component({
  selector: 'app-screen-share-required',
  standalone: true,
  imports: [CommonModule, FormsModule, Loader],
  templateUrl: './screen-share-required.component.html',
  styleUrl: './screen-share-required.component.css'
})
export class ScreenShareRequiredComponent {
  @Output() screenShared = new EventEmitter<MediaStream>();
  @Output() goBackEvent = new EventEmitter<void>();

  streamActive = false;
  stream: MediaStream | null = null;
  isLoading = false;
  errorMessage = 'Screen sharing not active.';
  organizationName: string = '';
  logoUrl: string | null = null;

  // Pre-share checklist
  closedOtherApps = false;

  constructor(private cdr: ChangeDetectorRef, private ngZone: NgZone) { }

  ngOnInit() {
    this.organizationName = sessionStorage.getItem('organization_name') || '';
    this.logoUrl = sessionStorage.getItem('logo_url');
  }

  get checklistComplete(): boolean {
    return this.closedOtherApps;
  }

  async shareScreen() {
    try {
      const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

      this.errorMessage = 'Requesting screen access...';
      this.cdr.detectChanges();

      const constraints = isSafari
        ? {
          video: {
            frameRate: { max: 5 },
            width: { max: 1280 },
            height: { max: 720 }
          }
        }
        : {
          video: {
            displaySurface: 'monitor',
            monitorTypeSurfaces: 'include',
            frameRate: { max: 5 },
            width: { max: 1280 },
            height: { max: 720 }
          } as any,
          audio: true,
          preferCurrentTab: false,
          selfBrowserSurface: 'exclude',
          surfaceSwitching: 'exclude',
        };

      this.stream = await navigator.mediaDevices.getDisplayMedia(constraints as any);

      const videoTrack = this.stream.getVideoTracks()[0];
      const settings = videoTrack.getSettings() as any;

      if (!isSafari && settings.displaySurface !== 'monitor') {
        this.stream.getTracks().forEach(t => t.stop());
        this.stream = null;
        this.streamActive = false;
        this.errorMessage = 'You must select "Entire Screen". Tab/Window sharing is not allowed.';
        this.cdr.detectChanges();
        return;
      }

      videoTrack.onended = () => {
        this.ngZone.run(() => {
          this.streamActive = false;
          this.stream = null;
          this.errorMessage = 'Screen sharing was stopped. Please share your entire screen again to continue.';
          this.cdr.detectChanges();
        });
      };

      this.streamActive = true;
      this.errorMessage = 'Screen verified. Starting interview...';
      this.cdr.detectChanges();
      
      // Auto-start the interview directly
      this.startInterview();
    } catch (e) {
      this.streamActive = false;
      this.errorMessage = 'Screen sharing was denied or failed.';
      this.cdr.detectChanges();
    }
  }

  startInterview() {
    if (this.streamActive && this.stream) {
      this.isLoading = true;
      this.cdr.detectChanges();
      this.screenShared.emit(this.stream);
    }
  }

  private stopScreenStream(): void {
    if (this.stream) {
      this.stream.getTracks().forEach(track => track.stop());
      this.stream = null;
    }
  }

  goBack() {
    this.stopScreenStream();
    this.goBackEvent.emit();
  }
}
